function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(theme) {
    return {
        wrapper: {
            base: {
                boxSizing: 'border-box',
                flex: '0 0',
                overflow: 'hidden',
                padding: '0 6px',
                '& > *': {
                    borderRadius: theme.size.border.radius.fiveX,
                    '& > img': {
                        borderRadius: theme.size.border.radius.fiveX
                    }
                }
            },
            inset: {
                padding: 0
            },
            notVisible: {
                pointerEvents: 'none',
                userSelect: 'none'
            }
        }
    };
};
var useStyle = function(param) {
    var cols = param.cols, insetControls = param.insetControls, isVisible = param.isVisible;
    var builtStyle = useBuildStyleWithTheme(buildStyle);
    if (!builtStyle) {
        return {
            wrapper: {}
        };
    }
    var wrapper = builtStyle.wrapper;
    var slideWidth = cols ? "".concat(100 / cols, "%") : '100%';
    return {
        wrapper: _objectSpread({}, wrapper.base, insetControls && wrapper.inset, !isVisible && wrapper.notVisible, {
            maxWidth: slideWidth,
            width: slideWidth,
            flexBasis: slideWidth
        })
    };
};
export default useStyle;
